module.exports = __webpack_public_path__ + "img/20250114_supplementplus_02.c058d2da.jpg";